module.exports = __webpack_public_path__ + "img/rlogo.82947ef7.png";